import { useLazyQuery, useMutation, useQuery, useSubscription } from "@apollo/client";
import bindOptions from "./bind-options";

export const dataModuleString = "data";

export const useDataQuery = bindOptions(useQuery, (c) => ({ ...c, context: { module: dataModuleString } })) as typeof useQuery;

export const useDataSubscription = bindOptions(useSubscription, (c) => ({
	...c,
	context: { module: dataModuleString },
})) as typeof useSubscription;

export const useLazyDataQuery = bindOptions(useLazyQuery, (c) => ({ ...c, context: { module: dataModuleString } })) as typeof useLazyQuery;

export const useDataMutation = bindOptions(useMutation, (c) => ({
	onError: (e) => console.error(e),
	...c,
	context: { module: dataModuleString } as any,
})) as typeof useMutation;
